/**
 * created 15.10.2025
 */
import React from 'react';
import type {PropsWithChildren} from 'react';
import './RatingStars.css';

type RatingStarsComponentType = PropsWithChildren<{
  rating: number; // 0..5, supports fractions like 4.3
  max?: number;   // optional, defaults to 5
  className?: string;
  style?: React.CSSProperties;
}>

const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value));

export function RatingStars({rating, max = 5, className, style}: RatingStarsComponentType) {
  const clampedRating = clamp(rating, 0, max);
  const percentage = (clampedRating / max) * 100;
  const label = `${clampedRating.toFixed(1)} out of ${max}`;
  const stars = '★★★★★'; // always render 5 characters to keep width consistent

  return (
    <div className={["testimonial-stars", className].filter(Boolean).join(' ')}
         style={style}
         aria-label={`Rating: ${label}`}
         role="img">
      <span className="stars-outer" aria-hidden="true">{stars}</span>
      <span className="stars-inner" style={{width: `${percentage}%`}} aria-hidden="true">{stars}</span>
    </div>
  );
}
